<template>
    <div class="vue_flex vue_column">
        <div class="cont_wrapper">
            <!-- <div class="home_title" style="margin-bottom: 21px">
        <div class="vue_flex">
          <div
            class="home_tit vue_relative h"
            :class="
              tabs.id === tabsId ? 'home_tit_active' : 'home_tit_activenot'
            "
            v-for="(tabs, tabsIndex) in tabsList"
            :key="tabsIndex"
            @click="tabsClick(tabs)"
          >
            <p>{{ tabs.title }}</p>
            <div
              class="home_solid vue_absolute"
              v-if="tabs.id === tabsId"
            ></div>
          </div>
        </div>

       
      </div> -->

            <!-- <el-table
        :data="listData"
        style="width: 100%"
        :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#333' }"
      >
        <el-table-column
          prop="nickname"
          label="负责人"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="goodsCount"
          label="管理链接数量"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="yewulirun"
          label="业务利润（支付）"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="xiaoshoushouru"
          label="销售收入"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="xiaoshoushouru"
          label="销售收入去退（支付）"
          align="center"
        ></el-table-column>
        <el-table-column prop="shouhoumoney" label="售后金额" align="center">
        </el-table-column>
      </el-table> -->
            <!-- <pagination
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="getHetongListFun"
      /> -->

            <div class="home_title">
                <div class="home_tit">
                    <p>绩效明细</p>
                </div>
            </div>
            <el-table :data="tableData" style="width: 100%"
                :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#333' }" max-height="250">
                <el-table-column prop="nickname" label="负责人" align="center"></el-table-column>

                <!-- <el-table-column prop="bili" label="提成比例" align="center"></el-table-column> -->
                <el-table-column prop="jinlirun" label="业务利润（支付）" align="center"></el-table-column>
                <el-table-column prop="maolirun" label="毛利（支付）" align="center">
                </el-table-column>
                <el-table-column prop="maolilv" label="毛利率 %（支付）" align="center">
                </el-table-column>
                <el-table-column prop="jinlirun" label="净利润（支付）" align="center">
                </el-table-column>
                <el-table-column prop="jinlirunlv" label="净利润率 %（支付）" align="center">
                </el-table-column>
                <el-table-column prop="xiaoshoushouru" label="销售收入" align="center"></el-table-column>
                <el-table-column prop="xiaoshounum" label="销售数量" align="center"></el-table-column>
                <el-table-column prop="xiaoshoushouru" label="销售收入去退（支付）" align="center"></el-table-column>
                <el-table-column prop="shouhoumoney" label="售后金额" align="center"></el-table-column>
                <el-table-column prop="tuikuailv" label="退款率 %（支付）" align="center"></el-table-column>
                <el-table-column prop="fahuoqiantuikuanjine" label="发货前退款金额" align="center"></el-table-column>
                <el-table-column prop="fahuobegintuikuanlv" label="发货后退款率 %（支付）" align="center"></el-table-column>
                <el-table-column prop="yewuchengben" label="业务成本（利润）" align="center"></el-table-column>
                <el-table-column prop="xianshangguanggaotoufangfeiyong" label="线上广告投放费用"
                    align="center"></el-table-column>
                <el-table-column prop="guanggaobi" label="广告投放费比" align="center"></el-table-column>
            </el-table>
            <!-- <pagination
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="getHetongListFun"
      /> -->
        </div>
    </div>
</template>
<script>
import Cookies from "js-cookie";
import * as echarts from "echarts";
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import linkboxs from "@/components/linkdata/index";

export default {
    components: { Pagination, linkboxs },

    data() {
        return {
            total: 0,
            listQuery: {
                page: 1,
                limit: 10,
                leixing: "zhichu",
            },

            opinionData: ["3", "2", "4", "4", "5"],
            tabsId: 1,
            tabsList: [
                { id: 1, title: "绩效排行" },
                { id: 2, title: "综合分排行" },
            ],

            listData: [],

            userObj: {},
            tableData: [],

            value1: "",
        };
    },
    mounted() {
        this.$nextTick(function () {
            this.drawLine("myChart");
        });
        // this.getHetongListFun();
        this.getBottomListFun();
    },

    methods: {
        drawLine(id) {
            this.charts = echarts.init(document.getElementById(id));
            this.charts.setOption({
                backgroundColor: "white", // 设置图表背景为白色
                tooltip: {
                    trigger: "axis",
                },
                legend: {
                    data: ["近七日收益"],
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "12%",
                    containLabel: true,
                },

                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: ["1", "2", "3", "4", "5"],
                },
                yAxis: {
                    type: "value",
                },

                series: [
                    {
                        name: "近七日收益",
                        type: "line",
                        stack: "总量",
                        data: this.opinionData,
                    },
                ],
            });
        },

        // async getHetongListFun() {
        //   const res = await this.$http.get( this.$urls.lirunribao_usershang, this.listQuery );
        //   if (res.errcode != 0) return DonMessage.error(res.errmsg);
        //   this.listData = res.allData;
        // },
        async getBottomListFun() {
            const res = await this.$http.get(this.$urls.lirunribao_userxia, this.listQuery);
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            // this.tableData = res.allData;
            let arr = [];
            for (let i in res.allData) {
                if (res.allData[i].goodsList.length > 0) {
                    for (let k in res.allData[i].goodsList) {
                        let item = {
                            ...res.allData[i],
                            ...res.allData[i].goodsList[k],
                        };
                        arr.push(item);
                    }
                } else {
                    let item = {
                        ...res.allData[i],
                    };
                    arr.push(item);
                }
            }
            // console.log(arr, '100000')
            this.tableData = arr;
        },
        tabsClick(row) {
            if (this.tabsId === row.id) return;
            this.tabsId = row.id;
            this.listQuery.page = 1
            this.$set(this.listQuery, 'leixing', Number(row.id === 1) ? 'zhichu' : 'fahuo')
            //   this.getHetongListFun();
            this.getBottomListFun();
        },


    },
};
</script>

<style lang="scss" scoped>
#myChart {
    width: 1508px;
    height: 300px;
    background: #f5f5f5;
}

.home_title {
    width: 100%;
    height: 55px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .home_tit {
        p {
            font-family: PingFang SC;
            font-weight: bold;
            font-size: 26px;
            margin-right: 47px;
        }

        .home_solid {
            width: 34px;
            height: 3px;
            background: #195cf8;
            border-radius: 2px;
            bottom: -12px;
            left: 50%;
            margin-left: -38px;
        }
    }

    .home_tit_active {
        color: rgba(25, 92, 248, 1);
    }

    .home_tit_activenot {
        color: rgba(35, 35, 35, 1);
    }

    .home_right {
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;

        .home_right_2 {
            width: 52px;
            height: 52px;
            border-radius: 50%;
            margin-left: 10px;
        }

        .home_right_1 {
            padding: 0 10px;
            width: 108px;
            height: 45px;
            background: #f4f5f9;
            border-radius: 10px;
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            align-items: center;
        }
    }
}

.shaixuan_btns {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;

    .shaixuan_btn1 {
        width: 132px;
        height: 55px;
        background: #ffffff;
        border-radius: 10px;
        border: 1px solid #999999;
        text-align: center;
        line-height: 55px;
    }

    .shaixuan_btn2 {
        margin-left: 25px;
        width: 131px;
        height: 54px;
        background: #195cf8;
        border-radius: 10px;
        text-align: center;
        line-height: 55px;
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 20px;
        color: #ffffff;
    }
}

.cont_wrapper {
    padding: 25px;

    .cont_wrapper_sx {
        width: 1527px;
        height: 71px;
        background: #f5f5f5;
        border-radius: 10px;
        padding: 0 20px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .shaixuan_left {
            display: flex;
            flex-direction: row;
            justify-content: start;
            align-items: center;
        }

        .shaixuan_item {
            width: 350px;
            height: 54px;
            background: #ffffff;
            border-radius: 10px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;
            margin-right: 22px;

            .shaixuan_item_con {
                display: flex;
                flex-direction: row;
                justify-content: start;
                align-items: center;

                .shaixuan_item_tit {
                    font-family: PingFang SC;
                    font-weight: 500;
                    font-size: 18px;
                    color: #232323;
                }

                .shaixuan_item_sel {
                    font-family: PingFang SC;
                    font-weight: 500;
                    font-size: 18px;
                    color: #999999;
                }

                .shaixuan_item_arr {
                    width: 13px;
                    height: 8px;
                    margin-left: 10px;
                }

                .shaixuan_item_icon {
                    width: 29px;
                    height: 24px;
                    margin-right: 10px;
                }
            }
        }
    }
}

.shaixuan_item {
    .el-input /deep/.el-input__inner {
        border: none !important;
        text-align: right;
        font-size: 18px;
    }

    .el-input /deep/.el-input__prefix {
        display: none !important;
    }

    .el-select /deep/.el-input__inner {
        border: none !important;
        text-align: right;
        font-size: 18px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/main/level1/channel/merits/index.vue